import React from 'react'
import { useParams } from "react-router-dom";
import EquipmentAlertViewMonitoringPage from 'components/inner/EquipmentAlertViewMonitoringPage';


const EquipmentAlertViewMonitoring = () => {
    const {id} = useParams();
    return (
        <EquipmentAlertViewMonitoringPage alertId={id} />
    )
}

export default EquipmentAlertViewMonitoring;